import React, { useState } from 'react';
import getIncludedResponse from '../../../../helpers/getIncludedResource';
import { connect, useSelector } from 'react-redux';
import { actions as screeningActions } from '../../redux/screeningActions';
import { MultipleChoiceQuestion } from '../MultipleChoiceQuestion/MultipleChoiceQuestion';
import { SingleChoiceQuestion } from '../SingleChoiceQuestion/SingleChoiceQuestion';
import { BooleanQuestion } from '../BooleanQuestion/BooleanQuestion';
import { BmiQuestion } from '../BmiQuestion/BmiQuestion';
import { InactiveQuestion } from '../InactiveQuestion/InactiveQuestion';
import './ConditionQuestions.scss';

const ConditionQuestions = ({ onSetAnswer, onEditAnswer, condition }) => {
  const { declaration } = useSelector((state) => state.screening);
  const [isEditingAnswer, setIsEditingAnswer] = useState('');

  const handleEditAnswer = (declarationNumber, conditionNumber, questionNumber) => {
    onEditAnswer(declarationNumber, conditionNumber, questionNumber);
    setIsEditingAnswer(questionNumber);
  };
  const questions = getIncludedResponse(condition, declaration.included, 'questions');

  return (
    <div className="condition-questions">
      <h4>Screening questions for {condition.attributes.name}</h4>
      {questions.length > 0 ? (
        Object.keys(questions).map((key, i) => {
          const question = questions[key];
          const answers = getIncludedResponse(question, declaration.included, 'selected');
          const answerText = answers?.map((a) => a.attributes.text).join(', ');
          switch (question.attributes.question_type) {
            case 'inactive':
              return (
                <InactiveQuestion
                  key={i}
                  declarationNumber={declaration?.data.attributes?.declaration_number}
                  conditionNumber={condition.attributes.number}
                  text={question.attributes.text}
                  questionNumber={question.attributes.number}
                  warning={question.attributes.warning}
                  onEditAnswer={handleEditAnswer}
                  bmiData={question.attributes.data}
                  answerText={answerText}
                  isEditingAnswer={isEditingAnswer === question.attributes.number}
                />
              );

            case 'bmi':
              return (
                <BmiQuestion
                  key={i}
                  conditionNumber={condition.attributes.number}
                  questionNumber={question.attributes.number}
                  question={question.attributes.data}
                  info={question.attributes.info}
                  onSetAnswer={onSetAnswer}
                  isEditingAnswer={isEditingAnswer === question.attributes.number}
                />
              );
            case 'bool':
              return (
                <BooleanQuestion
                  key={i}
                  conditionNumber={condition.attributes.number}
                  questionNumber={question.attributes.number}
                  onSetAnswer={onSetAnswer}
                  optionsList={getIncludedResponse(
                    question,
                    declaration.included,
                    'options',
                  )}
                  text={question.attributes.text}
                  info={question.attributes.info}
                  warning={question.attributes.warning}
                  isEditingAnswer={isEditingAnswer === question.attributes.number}
                />
              );
            case 'multiple-choice':
              return (
                <MultipleChoiceQuestion
                  key={i}
                  conditionNumber={condition.attributes.number}
                  questionNumber={question.attributes.number}
                  onSetAnswer={onSetAnswer}
                  optionsList={getIncludedResponse(
                    question,
                    declaration.included,
                    'options',
                  )}
                  text={question.attributes.text}
                  info={question.attributes.info}
                  isEditingAnswer={isEditingAnswer === question.attributes.number}
                />
              );

            case 'single-choice':
            default:
              return (
                <SingleChoiceQuestion
                  key={i}
                  conditionNumber={condition.attributes.number}
                  questionNumber={question.attributes.number}
                  optionsList={getIncludedResponse(
                    question,
                    declaration.included,
                    'options',
                  )}
                  text={question.attributes.text}
                  info={question.attributes.info}
                  questionId={question.id}
                  onSetAnswer={onSetAnswer}
                  isEditingAnswer={isEditingAnswer === question.attributes.number}
                />
              );
          }
        })
      ) : (
        <p>There are no questions to answer for this condition.</p>
      )}
    </div>
  );
};

export default connect(
  null,
  {
    onSetAnswer: screeningActions.setAnswer,
    onEditAnswer: screeningActions.editAnswer,
  },
)(ConditionQuestions);
